import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import axios from 'axios';

import './css/Login-Register.css';
import video1 from './assets/videos/11272939-uhd_2160_3840_25fps.mp4';
import video2 from './assets/videos/7063369-hd_1920_1080_24fps.mp4';
import video3 from './assets/videos/8231577-uhd_4096_2160_25fps.mp4';
import { MaterialResetPassword, MaterialPassword } from './MaterialComponents';


//TODO: move this to an environment variable
const resetPasswordtUrl = 'https://lkrse43p4g.execute-api.us-east-1.amazonaws.com/dev/resetpass';
const loadingSpinner = document.querySelector('.donut');

const loginArrowIcon = (
    <svg width="13" height="13" viewBox="0 0 13 13" fill="none" aria-hidden="true">
        <path
            d="M2.5 6.5h8M6.5 2.5l4 4-4 4"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);


const SetNewPassword = () => {
    const videos = [video1, video2, video3];
    const prefersReducedMotion = typeof window !== 'undefined'
        && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    const [passwordTwo, setPasswordTwo] = useState('');
    const [password, setPassword] = useState('');
    const [token, setToken] = useState('');
    const location = useLocation();

    //Learning Form Data (move it here)
    function handlePasswordTwoState(newValue) {
        setPasswordTwo(newValue);
    }
    function handlePasswordState(newValue) {
        setPassword(newValue);
    }

    const [message, setMessage] = useState('');
    const [isShown, setIsSHown] = useState(false);

    const [currentVideo, setCurrentVideo] = useState(0);
    const [fade, setFade] = useState(true);


    const navigate = useNavigate()

    const loginHandler = () => {
        //console.log('lets register woooo')
        // navigate('/register');
        navigate('/login');
    }

    const submitHandler = (event) => {
        event.preventDefault();
        const errors = [];

        if (password.trim() === "") {
            errors.push("Please enter a new password.");
        }
        
        if (password.length > 0 && password.length < 8) {
            errors.push("Password must be at least 8 characters.");
        }
        
        if (password !== passwordTwo) {
            errors.push("Passwords do not match.");
        }
        
        if (errors.length > 0) {
            setMessage(errors.join(" "));
            return;
        }

        setMessage(null)
        setMessage('Resetting Password...')
        
        //TODO: move this to an environment variable
        const requestConfig = {
            headers: {
                'x-api-key': 'mCQrNSvy7X5AUdJlF2ybc3LdEFGndN885kzttyvB'
            }
        }

        const requestBody = {
            token: token,
            password: password
        }

        console.log(requestBody)

        axios.post(resetPasswordtUrl, requestBody, requestConfig).then(response => {
            // setUserSession(response.data.user, response.data.token);
            // //console.log('login data response')
            //console.log(response.data.user)
            // //console.log(response.data.user.onboardingComplete)
            // //TODO: fix bug -- update always shows up
            // if(!response.data.user.onboardingComplete){
            //     navigate('/onboarding-demo');
            // }
            // else{
            //     document.querySelector('.header').style.display = 'block'
            //     navigate('/daily-content'); 
            // }
            setMessage(response.data.message)
            
        }).catch(error => {
            //TODO: fix error of receiving null error
            if(error.response.status === 400 || error.response.status === 401 || error.response.status === 403 ){
                setMessage(error.response.data.message);
            }
            else{
                setMessage('Sorry the server is down. Please try again later.');

            }
        })
    }

    useEffect(() => {
        const appElement = document.querySelector('.App');
        if (appElement) {
            appElement.style.background = '#000000';
            appElement.style.boxShadow = 'none';
            appElement.style.borderRadius = '0';
        }
        document.body.style.background = '#000000';
        document.body.style.color = '#FFFFFF';

        return () => {
            if (appElement) {
                appElement.style.background = '';
                appElement.style.boxShadow = '';
                appElement.style.borderRadius = '';
            }
            document.body.style.background = '';
            document.body.style.color = '';
        };
    }, []);

    useEffect(() => {
        document.querySelector('.header').style.display = 'none'
        if (loadingSpinner) {
            //console.log('deleting donute')
            loadingSpinner.style.display = 'none'; // Example: Change the text color
        }

        const params = new URLSearchParams(location.search);
        const resetToken = params.get("token");
        if (resetToken) {
            setToken(resetToken);
            console.log('here is the reset token: ', resetToken)
        } else {
            setMessage("Link expired. Request a new password reset link.");
        }
    }, [location]);

    useEffect(() => {
        const el = document.getElementById('set-new-password-root');
        if (el) el.classList.add('playing');
    }, []);

    useEffect(() => {
        const prevBody = document.body.style.overflow;
        const prevHtml = document.documentElement.style.overflow;
        document.body.style.overflow = 'hidden';
        document.documentElement.style.overflow = 'hidden';
        return () => {
            document.body.style.overflow = prevBody;
            document.documentElement.style.overflow = prevHtml;
        };
    }, []);

    useEffect(() => {
        if (prefersReducedMotion) {
            return undefined;
        }

        let switchTimeout;
        const timer = setInterval(() => {
            setFade(false);

            switchTimeout = setTimeout(() => {
                setCurrentVideo((prev) => (prev + 1) % videos.length);
                setFade(true);
            }, 250);
        }, 7000);

        return () => {
            clearInterval(timer);
            if (switchTimeout) {
                clearTimeout(switchTimeout);
            }
        };
    }, [prefersReducedMotion, videos.length]);

    return (
        <div
            id="set-new-password-root"
            className="auth-container auth-cinematic-page login-root--form-open"
            style={{ background: prefersReducedMotion ? '#0D1210' : '#000000' }}
        >
            {!prefersReducedMotion && (
                <div className="login-video-bg" aria-hidden="true">
                    <video
                        key={currentVideo}
                        src={videos[currentVideo]}
                        autoPlay
                        muted
                        playsInline
                        loop={false}
                        className="login-video-element"
                        style={{ opacity: fade ? 1 : 0 }}
                    />
                </div>
            )}
            <div className="login-video-overlay" aria-hidden="true" />
            <div className="login-video-grain" aria-hidden="true" />

            <div className="login-content-layer">
                <div className="login-inner">
                    <div className="login-bottom">
                        <form onSubmit={submitHandler} className="login-form login-form--open">
                            <div className="login-form-stack">
                                <div className="login-form-main">
                                    <div className="login-form-header">
                                        <h4 className="form-title form-headline">Create new password</h4>
                                    </div>

                                    <div className="login-form-fields">
                                        <p className="reset-form-copy">Your new password must be different from previous passwords.</p>
                                        <div className="field-password login-field">
                                            <div className="relapseQuestion">password:</div>
                                            <MaterialResetPassword handleChange={handlePasswordTwoState} value={passwordTwo}/>
                                        </div>
                                        <div className="field-password login-field">
                                            <div className="relapseQuestion">confirm password:</div>
                                            <MaterialPassword handleChange={handlePasswordState} />
                                        </div>
                                    </div>
                                </div>

                                <div className="login-form-footer">
                                    {message && <p className="message"> { message } </p>}
                                    <button type="submit" className="homeBttn btn-login">
                                        Reset Password
                                        {loginArrowIcon}
                                    </button>
                                    <button type="button" className="homeBttn btn-about" onClick={loginHandler}>Go To Login</button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    )
}


export default SetNewPassword;
